import React from 'react'
import { Tooltip as AntdTooltip, TooltipProps } from 'antd'
import { useTheme } from 'styled-components'
import { ThemeModes } from 'theme/theme'

const Tooltip = (props: TooltipProps) => {
    const theme = useTheme()

    return (
        <AntdTooltip
            color={
                theme.mode === ThemeModes.HIGH_CONTRAST
                    ? theme.highContrast.colorBgElevated
                    : ''
            }
            overlayInnerStyle={{
                color:
                    theme.mode === ThemeModes.HIGH_CONTRAST
                        ? theme.highContrast.primary
                        : theme.white,
            }}
            {...props}
        />
    )
}

export default Tooltip
